module.exports = __webpack_public_path__ + "img/accueil.20c95c12.png";